import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "../../../utils/router";
import { getLink, objectToFormData, toast } from "../../../utils/helpers";
import { postRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";
import Form from "./Form";

const Create = () => {
    const history = useHistory();
    const location = useLocation();

    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [insumo, setInsumo] = useState({
        tipo: '',
        nombre: '',
        unidad: '',
        referencia: '',
        costo: '',
        impuesto: '',
        costo_total: '',
        cantidad: '',
        descripcion: '',
    });
    const [esValido, setEsValido] = useState(false);

    const cancelar = () => {
        const from = location.state?.from || getLink("/salud/inventario");

        history.push(from);
    }

    const crearInsumo = async (exit = true) => {
        if (!esValido) return toast('Favor llenar todos los campos requeridos', 'error');

        setSaving(true);

        setErrors({});

        const data = objectToFormData(insumo);

        const response = await postRequest(apiUrl("salud/insumos"), data);
        
        if (response.success) {
            setInsumo({
                tipo: '',
                nombre: '',
                unidad: '',
                referencia: '',
                costo: '',
                impuesto: '',
                costo_total: '',
                cantidad: '',
                descripcion: '',
            });

            toast('Insumo Creado', 'success');

            if (exit) history.push(getLink("/salud/inventario"));
        }
        if (response.code === 422) {
            setErrors(response.data.message);
        }

        setSaving(false);
    };

    return <>
        <div className="row">
            <div className="col-md-12 order-2 order-md-1">
                <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
                    <h1>Crear Insumo</h1>

                    <Form insumo={insumo} setInsumo={setInsumo} setEsValido={setEsValido} errors={errors} saving={saving} />
                </div>
            </div>
        </div>

        <div className="row pt-4">
            <button
                type="button"
                className="btn btn-plain ml-auto mr-2"
                onClick={cancelar}
            >
                Descartar
            </button>

            <button
                type="button"
                className="btn btn-outline-primary mx-2"
                onClick={() => crearInsumo(false)}
            >
                Guardar y crear nueva
            </button>

            <button
                type="button"
                className="btn btn-primary ml-2 mr-3"
                onClick={() => crearInsumo(true)}
            >
                Guardar
            </button>
        </div>
    </>;;
};

export default Create;